export default __webpack_public_path__ + "64eabe308bfc58208a8fa945a2312dcd.png";